var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"documentation"}},[_c('button',[_vm._v("Voir maintenant →")]),_c('button',{on:{"click":_vm.emitGoPlan}},[_vm._v("Voir plus tard →")])])])}
var staticRenderFns = []

export { render, staticRenderFns }